import { GlobalProvider } from '@context/Global/GlobalProvider';
// import { ConfigProvider } from 'antd';
import 'antd/dist/antd.min.css';
import 'moment/locale/ja';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';

import App from './App';
import { RETRY, WINDOW_FOCUS_REFETCH } from './constants/useQueryOption';
import './i18n';
import './index.scss';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: RETRY,
            refetchOnWindowFocus: WINDOW_FOCUS_REFETCH,
        },
    },
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <GlobalProvider>
        {/* <ConfigProvider> */}
        <QueryClientProvider client={queryClient}>
            <App />
            {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> */}
        </QueryClientProvider>
        {/* </ConfigProvider> */}
    </GlobalProvider>,
);
